import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

type initialType = {
  locationId: string;
  resourceId: string;
};
const initialState: initialType = {
  locationId: "0",
  resourceId: "0",
};

type organisationReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const changeLocationId: organisationReducer<{ id: string }> = (
  state,
  action
) => {
  state.locationId = action.payload.id;
};

const changeResourceId: organisationReducer<{ id: string }> = (
  state,
  action
) => {
  state.resourceId = action.payload.id;
};

const organisationSlice = createSlice({
  initialState,
  name: "organisation",
  reducers: {
    changeLocationId,
    changeResourceId,
  },
});

export default organisationSlice;
